const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging';

const getConfig = () => {
  switch (ENV) {
    case 'prod':
    case 'production':
      return {
        api: {
          baseUrl: 'https://web.confidanthealth.com/api/rest',
          elkUrl: 'https://ch-prod.es.us-east-2.aws.elastic-cloud.com/prod_',
          socketClientUrl: 'wss://prod2-chat.confidantdemos.com/',
          oneSignalAppId: '6b0fc72c-d9a7-41bc-8342-56a25e05b24c',
          timeout: 60000,
        },
      };
    case 'staging':
      return {
        api: {
          baseUrl: 'https://staging.confidantdemos.com/rest',
          elkUrl: 'https://elastic-staging.confidanthealth.com/qa_',
          socketClientUrl: 'wss://staging-chat.confidantdemos.com/',
          oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
          timeout: 60000,
        },
      };
    case 'qa':
      return {
        api: {
          baseUrl: 'https://qa.confidantdemos.com/rest',
          elkUrl: 'https://elastic-staging.confidanthealth.com/qa_',
          socketClientUrl: 'wss://qa-chat.confidantdemos.com/',
          oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
          timeout: 60000,
        },
      };
    case 'sit2':
      return {
        api: {
          baseUrl: 'https://sit2.confidantdemos.com/rest',
          elkUrl: 'https://elastic-staging.confidanthealth.com/qa_',
          socketClientUrl: 'wss://sit2-chat.confidantdemos.com/',
          timeout: 60000,
        },
        sendbird: {
          appId: '41FCE9D5-9B0D-43F2-9B00-46D7F5F7C99C', // TODO: Replace with Dev Sendbird App ID
        },
        opentok: {
          apiKey: '46419812',
        },
      };
    case 'local':
      return {
        api: {
          elkUrl: 'https://elastic-staging.confidanthealth.com/sit1',
          baseUrl: 'http://localhost:[port]',
          socketClientUrl: 'wss://sit1-chat.confidantdemos.com/',
          oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
          timeout: 60000,
        },
        sendbird: {
          appId: '41FCE9D5-9B0D-43F2-9B00-46D7F5F7C99C',
        },
        opentok: {
          apiKey: '46419812',
        },
      };
    case 'development':
      return {
        api: {
          baseUrl: 'https://qa.confidantdemos.com/rest',
          elkUrl: 'https://elastic-staging.confidanthealth.com/qa_',
          socketClientUrl: 'wss://qa-chat.confidantdemos.com/',
          oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
          timeout: 60000,
        },
      };
    case 'sit1':
      return {
        api: {
          elkUrl: 'https://elastic-staging.confidanthealth.com/sit1',
          baseUrl: 'https://sit1.confidantdemos.com/rest', // 'https://sit1.confidantdemos.com/rest',
          socketClientUrl: 'wss://sit1-chat.confidantdemos.com/',
          oneSignalAppId: '660a6f2d-471a-40f8-9ad0-a0a16f99eebb',
          timeout: 60000,
        },
        sendbird: {
          appId: '41FCE9D5-9B0D-43F2-9B00-46D7F5F7C99C', // Sendbird SIT1
        },
        opentok: {
          apiKey: '46419812',
        },
      };
    default:
      throw Error(`Unconfigured environment '${ENV}'. Can be configured in src/config.js.`);
  }
};

export default getConfig();
